(function ($) {

    // Content product - change image on color variation hover

    var current_name = ""

    function switch_variation() {
        let variation_data = $(this).data("product"),
                $variation_title = $(this).closest(".content-product").find(".products_item__color_name"),
                $variation_content = $(this).closest(".content-product").find(".products_item__content")

        // If variation data is not set
        if (!variation_data) {
            return;
        }

        // Set as active
        $(this).siblings(".current").removeClass("current")
        $(this).addClass("current")

        // Switch content
        if (variation_data.content) {
            $variation_content.replaceWith(variation_data.content)
        }

        // Switch name
        if (variation_data.title) {
            current_name = variation_data.title
            $variation_title.text(variation_data.title)
        }
        init_archive_hover_image()
    }

    function variation_name_preview() {
        let variation_data = $(this).data("product"),
                $variation_title = $(this).closest(".content-product").find(".products_item__color_name")

        current_name = $variation_title.text()
        $variation_title.text(variation_data.title)
    }

    function variation_name_undo_preview() {
        let $variation_title = $(this).closest(".content-product").find(".products_item__color_name")
        $variation_title.text(current_name)
    }

    function init_archive_hover_image(){

        // Do not use on touch devices
        if(('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)){
            return
        }

        $(".content-product__link_content").off("mouseenter mouseleave" ); // unbind previsously binded events

        $(".content-product__link_content").hover(function(){

            var $hover_image = $(this).find('.content-product__images_hover_img')

            // Change image
            if($hover_image.length > 0){

                // Show variation product image
                if($hover_image.hasClass("lazyloaded")){
                    $hover_image.show()
                    $(this).find('.content-product__images_img').hide()
                }else{
                    // Show to load but set opacity 0 until image is loaded
                    $hover_image.css({
                        "opacity": "0",
                        "position": "absolute"
                    })
                    $hover_image.show()

                    $hover_image.on("load", () => {

                        // Remove all set css
                        $hover_image.css({
                            "opacity": "",
                            "position": ""
                        })

                        // Check if still hover
                        if($(this).is(":hover")){
                            $(this).find('.content-product__images_img').hide()
                        }
                    })
                }
            }

        }, function(){

            var $hover_image = $(this).find('.content-product__images_hover_img')

            // Change image
            if($hover_image.length > 0){
                // Show variation product image
                $(this).find('.content-product__images_img').show()
                $hover_image.hide()
            }

        })
    }

    function init_variations() {
        $(".products_item__color").hover(variation_name_preview, variation_name_undo_preview); // bind event again
        $(".products_item__color").click(switch_variation); // bind event again
    }

    init_variations()
    init_archive_hover_image()
    $(document).on("ajax_products_loaded", init_variations, init_archive_hover_image)


})(jQuery);